export const formatPercentValue = (value: number) => {
  const fixed = value.toFixed(2);
  return fixed.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
};

export const toPercentInputValue = (rate?: number | null) => {
  if (rate === undefined || rate === null) {
    return "";
  }
  return formatPercentValue(rate * 100);
};

export const convertSamplingRate = (rate?: number | null) => {
  const rateVal = rate === undefined || rate === null ? 1 : rate;
  return rateVal * 100;
};

export const getSamplingRatePercentage = (rate?: number | null) => {
  return `${formatPercentValue(convertSamplingRate(rate))}%`;
};

export const describeSamplingRate = (rate?: number | null) => {
  const ratePercentage = convertSamplingRate(rate);

  if (ratePercentage === 100) {
    return "Always on";
  }
  if (ratePercentage === 0) {
    return "Disabled";
  }
  return `${formatPercentValue(ratePercentage)}% of sessions`;
};

export type SamplingRateParseResult = {
  rate: number | undefined;
  error: string;
};

export const parseSamplingRate = (value: string): SamplingRateParseResult => {
  const trimmed = value.trim();
  if (!trimmed) {
    return { rate: undefined, error: "" };
  }

  const parsed = Number(trimmed);
  if (Number.isNaN(parsed)) {
    return { rate: undefined, error: "Enter a valid number" };
  }

  if (parsed < 0 || parsed > 100) {
    return { rate: undefined, error: "Enter a value between 0 and 100" };
  }

  if (parsed === 100) {
    // Treat 100% the same as "always on"
    return { rate: undefined, error: "" };
  }

  return { rate: Number((parsed / 100).toFixed(4)), error: "" };
};
